import Grid from "@mui/material/Grid";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import fr from "date-fns/locale/fr";
import moment from "moment";

// Material Dashboard 2 PRO React components
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";

export default function ReserveInfos({
  deviceId,
  edit,
  reserveDescription,
  setReserveDescription,
  reserveDate,
  setReserveDate,
  removalDate,
  setRemovalDate,
  filename1,
  setFilename1,
  filename2,
  setFilename2,
  filename3,
  setFilename3,
}) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item lg={3} xs={6}>
          <Stack component="form" noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Date de signalement"
                value={reserveDate && new Date(reserveDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setReserveDate(null);
                  } else setReserveDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
        <Grid item lg={3} xs={6}>
          <Stack component="form" noValidate>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
              <DatePicker
                slotProps={{ field: { clearable: true } }}
                displayWeekNumber
                label="Date de correction"
                value={removalDate && new Date(removalDate)}
                onChange={(newValue) => {
                  if (newValue === null) {
                    setRemovalDate(null);
                  } else setRemovalDate(moment(newValue).format("YYYY-MM-DD"));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="dd/MM/yyyy"
              />
            </LocalizationProvider>
          </Stack>
        </Grid>
        <Grid item lg={6} xs={12}>
          <FormField
            multiline
            minRows={1}
            value={reserveDescription}
            onChange={(event) => setReserveDescription(event.target.value)}
            required
            variant="outlined"
            type="text"
            label="Commentaire"
          />
        </Grid>
        {!edit && (
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <MDTypography variant="body3">
              Vous pourrez ajouter les photos une fois la réserve créée 🙂
            </MDTypography>
          </Grid>
        )}
      </Grid>
    </MDBox>
  );
}
